import React, { FunctionComponent, MouseEvent } from 'react';

import FooterLink from '@gojob/ui-bits/Footer/Link';
import useTranslation from '../../translations/useTranslation';

declare global {
  interface Window {
    openAxeptioCookies?: () => void;
  }
}

const CookieLink: FunctionComponent = () => {
  const t = useTranslation();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (window) {
      window.openAxeptioCookies?.();
    }
  };

  return (
    <FooterLink as="a" href="#" onClick={handleClick}>
      {t('cookie_consent')}
    </FooterLink>
  );
};

export default CookieLink;
